import { ContentItemObject } from '../../../ContentManagementProvider/Context'
import { getZoneAbbrev } from '../ContentEditModal/Details/DateTimeSelector/helpers'

export const FIELD_NAMES = {
  TITLE: 'Title',
  ALTTEXT: 'AltText',
  DESCRIPTION: 'Description',
  IMAGE_BUCKET: 'ImageBucket',
  IMAGE_URL: 'ImageUrl',
  IMAGE_FILENAME: 'ImageFilename',
  IMAGE_MIME: 'ImageMime',
  IMAGE_KEY: 'ImageKey',
  IMAGE_SIZE: 'ImageSize',
  TAGS: 'Tags',
  ACADEMIC_FOCUS: 'AcademicFocus',
  LOCATION: 'MeetingLocation',
  LINK: 'Link',
  DATE: 'Date',
  START_TIME: 'StartTime',
  END_TIME: 'EndTime',
  IS_HIDDEN: 'IsHidden',
  IS_VIRTUAL: 'IsVirtual',
  IS_RECURRING: 'IsRecurring',
  VIDEO_LINK: 'VideoLink',
  ROOM_BOARD: 'RoomAndBoardAvailable',
  CREDITS_AWARDED: 'CreditsAwarded',
  MIN_CREDITS: 'MinCredits',
  MAX_CREDITS: 'MaxCredits',
  SEASON: 'Season',
  SEASON_DESCRIPTION: 'SeasonDescription',
  ADMISSIONS_DESCRIPTION: 'AdmissionDescription',
  COST_DESCRIPTION: 'CostDescription',
  FINANCIAL_AID: 'FinancialAidAvailable',
  ELIGIBILITY: 'Eligibility',
  CONTENT_TYPE: 'ContentType',
}

export const ERROR_MESSAGES = {
  REQUIRED: 'This field is required',
  TOO_EARLY: 'Time must be after start time',
  TOO_LATE: 'Time must be before end time',
  VALID_DATE: 'Date must be formatted MM/DD/YYYY',
  VALID_TIME: 'Time must be formatted 00:00 AM',
  VALID_URL: 'URL must be valid and begin with http:// or https://',
  VALID_LENGTH: 'Enter up to 60 characters',
  MAX_GREATER: 'Max credits must not be less than min credits',
}

export const DEFAULT_CONTENT_ITEM = {
  [FIELD_NAMES.TITLE]: '',
  [FIELD_NAMES.ALTTEXT]: '',
  [FIELD_NAMES.DESCRIPTION]: '',
  [FIELD_NAMES.IMAGE_BUCKET]: '',
  [FIELD_NAMES.IMAGE_URL]: '',
  [FIELD_NAMES.IMAGE_FILENAME]: '',
  [FIELD_NAMES.IMAGE_MIME]: '',
  [FIELD_NAMES.IMAGE_KEY]: '',
  [FIELD_NAMES.IMAGE_SIZE]: 0,
  [FIELD_NAMES.TAGS]: [],
  [FIELD_NAMES.ACADEMIC_FOCUS]: [],
  [FIELD_NAMES.DATE]: null,
  [FIELD_NAMES.LOCATION]: '',
  [FIELD_NAMES.LINK]: '',
  [FIELD_NAMES.START_TIME]: null,
  [FIELD_NAMES.END_TIME]: null,
  [FIELD_NAMES.IS_VIRTUAL]: false,
  [FIELD_NAMES.IS_RECURRING]: false,
  [FIELD_NAMES.IS_HIDDEN]: false,
} as ContentItemObject

export const DEFAULT_PROGRAM_ITEM = {
  [FIELD_NAMES.TITLE]: '',
  [FIELD_NAMES.ALTTEXT]: '',
  [FIELD_NAMES.DESCRIPTION]: '',
  [FIELD_NAMES.IMAGE_BUCKET]: '',
  [FIELD_NAMES.IMAGE_URL]: '',
  [FIELD_NAMES.IMAGE_FILENAME]: '',
  [FIELD_NAMES.IMAGE_MIME]: '',
  [FIELD_NAMES.IMAGE_KEY]: '',
  [FIELD_NAMES.IMAGE_SIZE]: 0,
  [FIELD_NAMES.VIDEO_LINK]: '',
  [FIELD_NAMES.SEASON]: [],
  [FIELD_NAMES.SEASON_DESCRIPTION]: '',
  [FIELD_NAMES.CREDITS_AWARDED]: false,
  [FIELD_NAMES.ADMISSIONS_DESCRIPTION]: '',
  [FIELD_NAMES.ACADEMIC_FOCUS]: [],
  [FIELD_NAMES.IS_VIRTUAL]: false,
  [FIELD_NAMES.LOCATION]: '',
  [FIELD_NAMES.LINK]: '',
  [FIELD_NAMES.ELIGIBILITY]: [],
  [FIELD_NAMES.COST_DESCRIPTION]: '',
  [FIELD_NAMES.FINANCIAL_AID]: false,
  [FIELD_NAMES.ROOM_BOARD]: false,
  [FIELD_NAMES.IS_HIDDEN]: false,
} as ContentItemObject

const zoneAbbrev = getZoneAbbrev()
export const LABELS = {
  TITLE: 'Title',
  ALTTEXT: 'Alt Text',
  DESCRIPTION: 'Description',
  IMAGE: 'Choose Image',
  RECURRING: 'Recurring',
  HAPPENS_ONCE: 'Happens Once',
  VIRTUAL: 'Virtual',
  IN_PERSON: 'In Person',
  DATE: 'Date',
  RECURRING_DATE: 'Repeats until',
  START_TIME: `Start Time ${zoneAbbrev ? `(${zoneAbbrev})` : ''}`,
  END_TIME: `End Time ${zoneAbbrev ? `(${zoneAbbrev})` : ''}`,
  LOCATION: 'Location',
  LINK: 'Referral or Video URL',
  REGISTRATION: 'Registration URL',
  PROGRAM_WEBSITE: 'Program Website or Application URL',
  LINK_PLACEHOLDER: 'https://scoir.com',
  CATEGORIES: 'Categories',
  ACADEMIC_FOCUS: 'Academic Focus',
  VIDEO_LINK: 'Video URL',
  ROOM_BOARD: 'Room and Board available',
  CREDITS_AWARDED: 'Credits Awarded',
  NON_CREDIT: 'Non-Credit',
  MIN_CREDITS: 'Min Credits Awarded',
  MAX_CREDITS: 'Max Credits Awarded',
  SEASON: 'Season',
  WINTER: 'Winter',
  SPRING: 'Spring',
  SUMMER: 'Summer',
  FALL: 'Fall',
  SEASON_DESCRIPTION: 'Describe run dates and duration',
  ADMISSIONS_DESCRIPTION: 'Describe application process and deadline',
  COST_DESCRIPTION: 'Describe expected cost',
  FINANCIAL_AID: 'Financial Aid and Scholarships available',
  ELIGIBILITY: 'Eligible Grade(s)',
  CONTENT_TYPE: 'Content Type',
}
